import type { FC } from "react";
import heroImage from "../../../components/sideContent/resources/Image-Hero.png";
import heroImage2 from "../../../components/sideContent/resources/Image-Hero@2x.png";
import heroImage3 from "../../../components/sideContent/resources/Image-Hero@3x.png";
import appStoreImage from "../../../components/sideContent/resources/app-store.png";
import googlePlayImage from "../../../components/sideContent/resources/google-play.png";
import annaLogo from "../../../components/sideContent/resources/logo.svg";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "../shared/links";
import styles from "./pp2Banner.module.scss";

export type Pp2BannerProps = {
  /** "Get the free app" target, `Pp2ViewModel.bannerUrl` */
  url: string;
};

/** ANNA promo banner (spec 3.5, owner decision Q19). Always as wide as the content column. */
export const Pp2Banner: FC<Pp2BannerProps> = ({ url }) => (
  <aside className={styles.banner} aria-label="About ANNA" data-test-id="pp2-banner">
    {/* The picture comes first so the focus order (store badges, then the pill) follows the
        mobile/tablet column; on desktop the grid still puts it on the right */}
    <div className={styles.picture}>
      <img
        className={styles.image}
        src={heroImage}
        srcSet={`${heroImage2} 2x, ${heroImage3} 3x`}
        alt="ANNA app and business debit card"
      />
      <div className={styles.badges}>
        <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
          <img src={appStoreImage} alt="Download on the App Store" />
        </a>
        <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer">
          <img src={googlePlayImage} alt="Get it on Google Play" />
        </a>
      </div>
    </div>
    <div className={styles.text}>
      <img className={styles.logo} src={annaLogo} alt="ANNA" />
      <h2 className={styles.title}>Meet ANNA, the business account and tax app for your small business</h2>
      <p className={styles.body}>
        ANNA Money is the one-stop shop for all your business admin. Not only will you get a business account and debit
        card, we&rsquo;ll also sort your invoicing, expenses and company taxes. Sweet.
      </p>
      {/* The old /pp banner's pill (owner feedback), not the library Button */}
      <a className={styles.button} href={url}>
        Get the free app
      </a>
    </div>
  </aside>
);
